// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/swiper/dist/css/swiper.css
// module id = 193
// module chunks = 32